var _title, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTick = function SvgTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 18 18"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "\n    Tick\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.871 7.515C1.023 6.445-.61 7.733.237 8.803l4.12 5.201a1.049 1.049 0 001.7-.082L15.762 1.69c.849-1.07-.786-2.357-1.634-1.287l-8.95 11.282L1.87 7.515z"
  })));
};
export default SvgTick;